import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      marginLeft: 'auto',
      display: 'flex',
      gap: 8,
      alignItems: 'center',
    },
    findMoreButton: {
      background: 'var(--x-bg-6)',
      padding: [4, 8, 4, 12],
      borderRadius: 72,
      '& > span': {
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
    arrowButton: {
      borderRadius: 50,
      background: 'var(--x-bg-6)',
      padding: 4,
      '& > span': {
        fontSize: '12px',
        lineHeight: '16px',
        '& > svg': {
          width: 16,
          height: 16,
        },
      },
    },
  },
  { name: 'card-button' },
);

export default useStyles;
